const base = "https://unio-backend.herokuapp.com/api/v1";
// const base = "http://localhost:3000/api/v1";
//redeploy
const urls = {
  //users
  login: `${base}/user/login`,
  addUser: `${base}/user/admin`,
  getUsers: `${base}/users`,
  getUsersFilter: `${base}/users-filter`,
  updateOrDeleteUser: `${base}/user`,
  updatePassword: `${base}/user/reset-password`,
  sendTokenResetPassword: `${base}/user/token-password`,
  //doctors
  getDoctors: `${base}/doctors`,
  getSpecialties: `${base}/specialties`,
  getDoctorsPendingAproval: `${base}/doctor-users`,
  getDoctorAssignmentsTop: `${base}/doctor-assignments-top`,
  exportDoctors: `${base}/doctors/export-all`,
  uploadDoctors: `${base}/doctors/file`,
  //laboratories
  addLaboratory: `${base}/user/laboratory`,
  getLaboratories: `${base}/laboratories`,
  getChildLaboratoriesFilter: `${base}/laboratories-filter-childs`,
  getLaboratoryUsers: `${base}/laboratory-users`,
  getReports: `${base}/laboratory-reports`,
  updateStatusReport: `${base}/laboratory-report`,
  getUnreadReportsQuantity: `${base}/unread-reports-quantity`,
  getLabsWithoutOperators: `${base}/laboratories-without-operators`,
  //products
  getProductsPendingApproval: `${base}/products/status`,
  addOrUpdateOrDeleteProduct: `${base}/product`,
  getProducts: `${base}/products`,
  getProductsFilter: `${base}/products/search`,
  getProductsAssigned: `${base}/products/assigned`,
  assignProduct: `${base}/product/assign`,
  reAssignProduct: `${base}/patients-assign-products/resend`,
  assignProductCategory: `${base}/product/assign-category`,
  assignProductsFiles: `${base}/products/assign-excel`,
  updateProductStatus: `${base}/product-status`,
  getMostRequestedProducts: `${base}/most-requested-products`,
  deleteProductsAssignmet: `${base}/products/assign/delete`,
  getSamplesToRunOut: `${base}/samples-to-run-out`,
  getSamplesToExpire: `${base}/samples-to-expire`,
  getSamplesAvailable: `${base}/samples-available`,
  getAllProductsStatus: `${base}/products/avaible-status`,
  uploadProductStatus: `${base}/product-status`,
  assignProductsDoctors: `${base}/products/assignProductsDoctors`,
  assignProductsDoctorsByExcel: `${base}/products/assignProductsDoctorsByExcel`,
  downloadExampleAssignProductsDoctorsByExcel: `${base}/products/downloadExampleAssignProductsDoctorsByExcel`,
  exportAssignments: `${base}/patients-export-orders`,
  //operators
  getOperators: `${base}/operators`,
  addOrUpdateOperator: `${base}/operator`,
  getOperatorProducts: `${base}/operator-assign-products`,
  updateStatusAssign: `${base}/patients-assign-products`,
  getAllAssignProducts: `${base}/all-patients-assign-products`,
  assignLaboratories: `${base}/operator/laboratories`,
  findByLaboratory: `${base}/operator/laboratory`,
  getHistory: `${base}/operator/history`,
  //category
  addOrUpdateOrDeleteCategory: `${base}/category`,
  getCategoriesLaboratory: `${base}/categories-laboratory`,
  //orders
  getOrders: `${base}/orders`,
  updateOrder: `${base}/order`,
  getOrderStatus: `${base}/orders/list-by-status`,
  updateOrderStatus: `${base}/orders/update-status`,
  getExportPatientsOrders: `${base}/patients-export-orders`,
  //patients
  getPatientsAssignProducts: `${base}/patients-assign-products`,
  assignOperator: `${base}/patients-assign-operator`,
  getAssignedOperators: `${base}/patients-assigned-operators`,
  getRepetitionRate: `${base}/patients-repetition-rate`,
  // Download to pdf
  downloadAssignment: `${base}/documents/inDeliveryOrder`,
  downloadOperatorAssignments: `${base}/documents/inDeliveryOrders/operator`,
  downloadAssignmentWithPatientData: `${base}/documents/inDeliveryOrderPrivateData`,
  downloadOperatorAssignmentsWithPatientData: `${base}/documents/inDeliveryOrdersPrivateData/operator`,
  //Zones
  addVisitingZones: `${base}/visitingZones/add`,
  updateVisitingZone: `${base}/visitingZones/update`,
  getAVisitingZone: `${base}/visitingZones/getOne`,
  getVisitingZones: `${base}/visitingZones/getAllByLaboratory`,
  deleteVisitingZone: `${base}/visitingZones/deleteOne`,
  zonifyLabRepresentatives: `${base}/visitingZones/zonifyLabRepresentatives`,
  zonifyDoctors: `${base}/visitingZones/zonifyDoctors`,
  zonifyDoctorsByFile: `${base}/visitingZones/zonifyDoctorsByFile`,
  multizonification: `${base}/visitingZones/multizonification`,
  updateDoctorZones: `${base}/visitingZones/updateDoctorZones`,
  // getAssociatedUsersByLab:`visitingZones/getAssociatedUsersByLab/:laboratoryId`
  getAssociatedUsersByLab: `${base}/visitingZones/getAssociatedUsersByLab`,
  // Representatives
  addLabRepresentative: `${base}/labRepresentatives/add`,
  addManyByFile: `${base}/labRepresentatives/addManyByFile`,
  findLabRepresentativeById: `${base}/labRepresentatives/getOne`,
  findLabRepresentativesByLaboratory: `${base}/labRepresentatives/getAllByLaboratory`,
  deleteLabRepresentative: `${base}/labRepresentatives/deleteOne`,
  updateLabRepresentative: `${base}/labRepresentatives/updateOne`,
  assignToRepresentativesStocks: `${base}/labRepresentatives/assignToRepresentativesStocks`,
  // Refill
  getRefillCategories: `${base}/productsRefillCategories/list`,
  getDoctorsRefillCategories: `${base}/productsRefillCategories/listAllLabsDoctorsProductsRefillCategories`,
  addProductsRefillCategories: `${base}/productsRefillCategories/add`,
  editProductsRefillCategories: `${base}/productsRefillCategories/update`,
  deleteProductsRefillCategory: `${base}/productsRefillCategories/delete`,
  addBasalCategory: `${base}/productsRefillCategories/addBasalCategory`,
  updateDoctorCategory: `${base}/productsRefillCategories/updateDoctorCategory`,
  addDoctorCategory: `${base}/productsRefillCategories/categorizeDoctors`,
  deleteDoctorCategory: `${base}/productsRefillCategories/deleteDoctorCategory`,
  getAllDoctorsRefillCategorization: `${base}/productsRefillCategories/getAllDoctorsRefillCategorization`,
  // Consents
  addInformedConsents: `${base}/informedConsents/add`,
  patchInformedConsents: `${base}/informedConsents/patch`,
  listInformedConsents: `${base}/informedConsents/list`,
  downloadSignatories: `${base}/informedConsents/downloadSignatories`,
  getUserConsents: `${base}/informedConsents/searchbar`,
  downloadSignedSignatories: `${base}/documents/getSingleTermsAndCondSignature`,
  // Auth
  refreshToken: `${base}/user/refresh-token`,
  logout: `${base}/user/logout`,
};

export default urls;
